<template>
  <div>
    <Loading v-if="loading" />
    <div v-else class="campaign-overall-charts">
      <div class="campaign-overall-charts__chart">
        <CampaignOverallChart
          :series="stats.counts"
          :y-axis="$t('ADVERTISEMENT.CAMPAIGN.STATS.OVERALL.AXIS')"
          :second-y-axis="$t('ADVERTISEMENT.CAMPAIGN.STATS.OVERALL.AXIS')"
          :categories="stats.dates"
        />
      </div>
      <div class="campaign-overall-charts__chart">
        <CampaignOverallChart
          :series="stats.costs"
          :y-axis="
            $t('ADVERTISEMENT.CAMPAIGN.STATS.OVERALL.AVG_INSTALL_COST.AXIS')
          "
          :second-y-axis="
            $t('ADVERTISEMENT.CAMPAIGN.STATS.OVERALL.AVG_INSTALL_COST.AXIS')
          "
          :categories="stats.dates"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '@@/common/Loading';
import campaignId from '@/mixins/advertisement/campaignId';
import CampaignOverallChart from './CampaignOverallChart';

import { requestQueue } from '@/api/api';
import { AbortedError } from '@/api/shared/transformers/errorTransformer';

import AdInsight from '@/api/ad-insight';

export default {
  name: 'CampaignOverallCharts',
  components: {
    CampaignOverallChart,
    Loading,
  },
  mixins: [campaignId],
  props: {
    range: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      stats: {},
    };
  },
  watch: {
    range() {
      this.updateData();
    },
  },
  created() {
    this.getCampaignData();
  },
  methods: {
    getCampaignData() {
      this.loading = true;
      return AdInsight.getCampaignOverallStats(this.campaignId, this.range)
        .then(({ impression, avgInstallCost, install, cost, ...stats }) => {
          this.stats = {
            costs: [avgInstallCost, cost],
            counts: [impression, install],
            ...stats,
          };
        })
        .catch(error => {
          if (error instanceof AbortedError) return;
          const { message } = error;
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateData() {
      requestQueue.flush();
      this.getCampaignData();
    },
  },
};
</script>
<style lang="scss">
.campaign-overall-charts {
  &__chart:first-child {
    margin-bottom: $global-margin;
  }
}
</style>
